import React from 'react';
import { useSelector, useStore } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = (props) => {
    const { pathname } = useLocation();
    const { crumbs, className } = props
    const is_activation = useSelector(store => store?.userActivity?.is_activation)
 

    const handleLinkClick = (path) => {
        if (path === pathname) {
            window.location.reload();
        }
    }

    return (
        <h1 className={`text-black font-bold text-xs md:text-lg`}>
            {crumbs && crumbs.map(({ name, path }, idx) =>
                (idx + 1 === crumbs.length || path === "") ? (
                    <span key={idx}>{name}{idx + 1 !== crumbs.length && <span>&nbsp;/&nbsp;</span>} </span>
                ) : (
                    <div className='inline-flex' key={idx}>
                        <Link to={path} className={`${is_activation ? 'text-black' : 'text-lime-500'} md:hover:underline md:underline-offset-4 cursor-pointer`} onClick={(e) => handleLinkClick(path)}>
                            {name}
                        </Link>
                        <span>&nbsp;/&nbsp;</span>
                    </div>
                )
            )}
        </h1>
    );
};
export default Breadcrumb;